class VersionManager {
  constructor(features = {}, dateCreated = -8640000000000000) {
    this.features = features;
    this.dateCreated = dateCreated;
  }

  getVersion(featureName) {
    const featureVersions = this.features[featureName];
    if (!featureVersions) {
      return VersionManager.Versions.min;
    }
    for (let i = featureVersions.length-1; i >=0 ; i--) {
      if (this.dateCreated >= featureVersions[i].dateFrom) {
        return featureVersions[i].version;
      }
    }
  }
}

VersionManager.Versions = {
  min: "min",
}

module.exports = VersionManager;



// WEBPACK FOOTER //
// ./versioning/versionManager.js